var Vector = require("./vector");

/**
 * Returns a canvas position vector for the given browser event.
 *
 * @param ev    event
 *
 * @returns {Vector}
 */
module.exports = function (ev, screen)
{
    var x;
    var y;

    if (ev.pageX || ev.pageY)
    {
        x = ev.pageX;
        y = ev.pageY;
    }
    else
    {
        x = ev.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        y = ev.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }
    x -= screen.offsetLeft;
    y -= screen.offsetTop;

    return new Vector(x,y);
};
